import { createFileRoute } from '@tanstack/react-router'
import { FacultadesScreen } from '@web/app/features/facultades'
import { Library } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/admin/faculties')({
  component: FacultadesScreen,
  staticData: {
    metaRoute: {
      title: 'Facultades',
      order: 2,
      icon: Library,
    },
  },
})